// odometer.js — Zahlen rollen Ziffer für Ziffer (Bewegung Runde 3): nur die geänderten Stellen bewegen sich, jede mit
// eigener Feder, gestaffelt von rechts (die Einerstelle zuerst, wie ein Zählwerk). Steigt der Wert, kommt die neue Ziffer
// von unten, sinkt er, von oben. Der Text bleibt ein gewöhnlicher Text (Screenreader lesen den Endwert vor,
// textContent stimmt) — die Spans sind nur Bühne. Reduzierte Bewegung: der Text wechselt ohne Bewegung.
import { play, rollIn } from './motion.js';

/** Erste Zahl im Text (Tausenderpunkte/-leerzeichen ignoriert), sonst null. */
export function leadingNumber(s) {
  const m = String(s ?? '').match(/-?\d[\d.,   ]*/);
  if (!m) return null;
  const n = Number(m[0].replace(/[.   ]/g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

/** Welche Stellen (Index im neuen Text) sich gegenüber dem alten ändern — rechtsbündig verglichen, weil sich Zahlen von rechts aufbauen. */
export function changedChars(prev, next) {
  const a = [...String(prev ?? '')], b = [...String(next ?? '')];
  const out = [];
  for (let i = 0; i < b.length; i++) {
    const j = a.length - (b.length - i);
    if (j < 0 || a[j] !== b[i]) out.push(i);
  }
  return out;
}

/** Text setzen und geänderte Zeichen rollen lassen. Gibt die Zahl der bewegten Zeichen zurück. */
export function rollText(el, text, { stagger = 24, spring = 'spatial-fast' } = {}) {
  if (!el) return 0;
  const prev = el.dataset.odo ?? el.textContent;
  const next = String(text ?? '');
  el.dataset.odo = next;
  if (prev === next) return 0;
  const a = leadingNumber(prev), b = leadingNumber(next);
  const dir = a == null || b == null ? 1 : b >= a ? 1 : -1;
  const changed = new Set(changedChars(prev, next));
  // Unveränderte Teile bleiben Text; geänderte Zeichen werden zu Kästchen, zusammenhängend in einem nicht umbrechenden Lauf
  el.classList.add('vc-odo');
  const chars = [...next], nodes = [];
  for (let i = 0; i < chars.length;) {
    if (!changed.has(i) || !chars[i].trim()) {
      let j = i; while (j < chars.length && (!changed.has(j) || !chars[j].trim())) j++;
      nodes.push(document.createTextNode(chars.slice(i, j).join(''))); i = j; continue;
    }
    const run = document.createElement('span'); run.className = 'vc-odo-run';
    while (i < chars.length && changed.has(i) && chars[i].trim()) { const d = document.createElement('span'); d.className = 'vc-odo-d'; d.textContent = chars[i]; run.appendChild(d); i++; }
    nodes.push(run);
  }
  el.replaceChildren(...nodes);
  const moving = [...el.querySelectorAll('.vc-odo-d')].reverse();
  moving.forEach((s, k) => play(s, rollIn(dir), { spring, delay: Math.min(6, k) * stagger }));
  return moving.length;
}
